/**
 * Created by sswaminathan on 1/8/22
 * File: LicenseProductLegend
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { Toggle } from '@panwds/react-form-legacy'
import { Body, Bold } from '@panwds/react-ui'
/**
 *   TODO: Brief what is this component/class do
 */
import { useContext, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { APP_ID_PRISMA_ACCESS, APP_ID_PRISMA_ACCESS_EDITION } from '../../../common/constants/GlobalConstants'
import { DATA_TEST_ALLOCATE_LICENSE } from '../../../common/constants/TestingDataIds'
import AppContext from '../../../common/context/AppContext'

const LicenseProductLegend = ({ licenseDisplayName, handleProductSelection, licenseValue, disable, isPanChina, showToggle }) => {
  const { setValue } = useFormContext()
  const { getAppName } = useContext(AppContext)
  useEffect(() => {
    setValue(`${licenseValue}:${licenseDisplayName}`, !disable)
  }, [disable, licenseDisplayName, licenseValue, setValue])
  return (
    <legend
      className='tw-w-auto'>
      {showToggle ? <div className='tw-flex tw-flex-row'>
        <Toggle
          data-testid={DATA_TEST_ALLOCATE_LICENSE}
          label={`${licenseValue}:${licenseDisplayName}`}
          addClassName='tw-ml-2 tw-mt-3'
          defaultValue={false}
          disabled={disable}
          showLabel={false}
          name={`${licenseValue}:${licenseDisplayName}`}
          register={{
            onChange: (event) => {
              handleProductSelection(event.target.value, licenseDisplayName, licenseValue)
            }
          }} />
        <Body size='md' addClassName='tw-flex-nowrap tw-mx-2  tw-mt-3'><Bold>
          {`Activate ${getAppName(licenseDisplayName !== APP_ID_PRISMA_ACCESS_EDITION ? licenseDisplayName : APP_ID_PRISMA_ACCESS)}`}</Bold></Body>
      </div> : <></>}
    </legend>)
}

LicenseProductLegend.propTypes = {}
export default LicenseProductLegend
